<template>
	<div class="page list-page">
		<van-nav-bar :title="vod_name" class="nav-bar list-navbar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" size="18" @click="back()" />
			</template>
		</van-nav-bar>

		<van-pull-refresh
			v-model="isLoading"
			@refresh="onRefresh"
			:success-text="$t('reservation.refresh')"
			:pulling-text="$t('choose.pull_to_refresh')"
			:loosing-text="$t('choose.release_to_refresh')"
			:loading-text="$t('choose.refreshing')"
			class="list-pull"
		>
			<div class="list-scroll">
				<!-- 老师卡片（复用首页的卡片样式） -->
				<div class="teacher-list" v-if="datalist && datalist.length > 0">
					<div
						class="teacher-card"
						v-for="(v, k) in datalist"
						:key="k"
						@click="profile(v)"
					>
						<div class="teacher-img-wrap">
							<van-image
								class="teacher-img"
								:src="v.img_url"
								width="100%"
								height="100%"
								radius="12"
							>
								<template v-slot:loading>
									<van-loading type="spinner" size="20" />
								</template>
								<template v-slot:error>
									<div class="teacher-img-empty">
										<van-icon name="photograph" size="32" color="#bbb"/>
									</div>
								</template>
							</van-image>
						</div>
						<div class="teacher-info">
							<div class="teacher-title-row">
								<div class="teacher-names">
									<div class="name-with-badge">
										<span class="v-badge">
											<svg xmlns="http://www.w3.org/2000/svg" class="v-badge-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
												<path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"></path>
												<path d="m9 12 2 2 4-4"></path>
											</svg>
											<span class="v-badge-text">{{ $t('choose.v_verified') }}</span>
										</span>
										<span class="teacher-nick">{{ v.xuanfei_name }}</span>
									</div>
									<span class="teacher-real" v-if="v.teacher_name">{{ v.teacher_name }}</span>
								</div>
							</div>

							<!-- 标签：放在名字下方（A/B 标签统一米黄圆角深棕样式） -->
							<div class="teacher-tags-below" v-if="splitTags(v.tag_a).length + splitTags(v.tag_b).length > 0">
								<div class="teacher-tags-row" v-if="splitTags(v.tag_a).length > 0">
									<span class="tag-badge" v-for="(t,ti) in splitTags(v.tag_a)" :key="'ca-'+ti">{{ t }}</span>
								</div>
								<div class="teacher-tags-row" v-if="splitTags(v.tag_b).length > 0">
									<span class="tag-badge" v-for="(t,ti) in splitTags(v.tag_b)" :key="'cb-'+ti">{{ t }}</span>
								</div>
							</div>

							<div class="teacher-base-row">
								<span class="base-item" v-if="v.age">{{ v.age }}{{ $t('choose.age_unit') }}</span>
								<span class="base-sep" v-if="v.age && v.height">·</span>
								<span class="base-item" v-if="v.height">{{ v.height }}cm</span>
								<span class="base-sep" v-if="(v.age||v.height) && v.weight">·</span>
								<span class="base-item" v-if="v.weight">{{ v.weight }}kg</span>
								<span class="base-sep" v-if="(v.age||v.height||v.weight) && v.education">·</span>
								<span class="base-item" v-if="v.education">{{ v.education }}</span>
							</div>
							<div class="teacher-city-row">
								<van-icon name="location-o" size="12" color="#999" class="city-icon"/>
								<span class="city-text" v-if="v.service_city">{{ v.service_city }}</span>
								<span class="city-text hometown" v-if="v.hometown">（{{ $t('choose.hometown_label') }}：{{ v.hometown }}）</span>
							</div>
							<div class="teacher-action-row">
								<button type="button" class="detail-btn" @click.stop="profile(v)">{{ $t('choose.view_detail') }}</button>
							</div>
						</div>
					</div>
				</div>

				<!-- 空状态 -->
				<div class="empty-state" v-else>
					<svg viewBox="0 0 200 200" width="140" height="140" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
						<rect x="0" y="0" width="200" height="200" fill="none"/>
						<rect x="38" y="30" width="124" height="140" rx="14" fill="#f5f5f7" stroke="#e6e6eb" stroke-width="2"/>
						<circle cx="100" cy="80" r="24" fill="#e6e6eb"/>
						<path d="M58 146 C66 122 82 112 100 112 C118 112 134 122 142 146 Z" fill="#e6e6eb"/>
						<rect x="60" y="172" width="80" height="4" rx="2" fill="#ededf0"/>
					</svg>
					<p class="empty-text">{{ $t('choose.no_teacher') }}</p>
				</div>
			</div>
		</van-pull-refresh>
	</div>
</template>

<script>
export default {
	data() {
		return {
			vod_name: '',
			isLoading: false,
			datalist: []
		};
	},
	methods: {
		/**
		 * 统一解析 DB 里的标签字段，兼容三种格式：数组 / JSON字符串 / 逗号分隔文本
		 */
		splitTags(val) {
			if (val === null || val === undefined) return [];
			if (Array.isArray(val)) {
				return val.map(String).filter(t => (t || '').trim().length > 0);
			}
			let str = String(val).trim();
			if (!str) return [];
			try {
				let arr = JSON.parse(str);
				if (Array.isArray(arr)) {
					return arr.map(String).filter(t => (t || '').trim().length > 0);
				}
			} catch (e) {
				// 不是合法 JSON，忽略并继续按分隔符拆分（后台可能直接存 "A,B,C"）
			}
			let parts = str.split(/[,，;；\s]+/).filter(t => t.trim().length > 0);
			return Array.from(new Set(parts.map(String)));
		},
		back() {
			this.$router.push({ path: 'Choose' });
		},
		onRefresh() {
			this.getxuanfeilist().finally(() => {
				this.isLoading = false;
			});
		},
		profile(v) {
			this.$router.push({
				path: '/profile',
				query: {
					id: v.id,
					name: this.vod_name,
					adsid: this.$route.query.id
				}
			});
		},
		getxuanfeilist() {
			return new Promise((resolve) => {
				this.$http({
					method: 'get',
					url: 'xuanfeilist',
					data: { id: this.$route.query.id }
				}).then(res => {
					this.datalist = (res && res.data) ? res.data : [];
					resolve();
				}).catch(() => {
					this.datalist = [];
					resolve();
				});
			});
		}
	},
	created() {
		this.vod_name = this.$route.query.name || this.$t('choose.the_region');
		this.getxuanfeilist();
	}
};
</script>

<style scoped>
.list-page {
	background: #f7f8fa;
	min-height: 100vh;
}
.list-navbar ::v-deep .van-nav-bar__content {
	background: linear-gradient(135deg, #7f5778 0%, #c98a9c 55%, #e5c2a0 100%);
}
.list-navbar ::v-deep .van-nav-bar__title {
	color: #fff;
	font-weight: 600;
}
.list-pull {
	min-height: calc(100vh - 46px);
}
.list-scroll {
	padding: 10px 14px 20px;
}

/* 复用卡片样式，与 choose/index.vue 保持一致 */
.teacher-card {
	display: flex;
	background: #fff;
	border-radius: 16px;
	padding: 12px;
	margin-bottom: 12px;
	box-shadow: 0 2px 10px rgba(20,20,40,0.04);
}
.teacher-img-wrap {
	width: 120px;
	height: 150px;
	flex-shrink: 0;
	border-radius: 12px;
	overflow: hidden;
	background: #f2f3f5;
}
.teacher-img {
	width: 100%;
	height: 100%;
}
.teacher-img ::v-deep .van-image__img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.teacher-img-empty {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fafafa;
}
.teacher-info {
	flex: 1;
	min-width: 0;
	margin-left: 12px;
	display: flex;
	flex-direction: column;
}
.teacher-title-row {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
}
.teacher-names {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.teacher-nick {
	font-size: 36px;
	font-weight: 600;
	color: #1d1d1f;
}
.teacher-real {
	font-size: 26px;
	color: #888;
	margin-left: 8px;
}
.teacher-base-row {
	margin-top: 6px;
	font-size: 25px;
	color: #666;
	line-height: 1.5;
}
.base-item + .base-sep { margin: 0 4px; color: #d0d0d5; }
.base-sep { color: #d0d0d5; margin: 0 4px; }
.teacher-city-row {
	margin-top: 6px;
	font-size: 25px;
	color: #888;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
}
.city-icon { margin-right: 4px; flex-shrink: 0; }
.city-text.hometown { color: #aaa; margin-left: 2px; }
/* 标签整体：放在名字下面，统一样式 */
.teacher-tags-below {
	margin-top: 10px;
}
.teacher-tags-row {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}
.teacher-tags-row + .teacher-tags-row {
	margin-top: 6px;
}
.tag-badge {
	display: inline-block;
	padding: 4px 10px;
	font-size: 24px;
	line-height: 1.4;
	border-radius: 6px;
	background: #f7ddc7;
	color: #3d2f1a;
	white-space: nowrap;
}
.teacher-action-row {
	margin-top: auto;
}
.detail-btn {
	border: none;
	outline: none;
	margin-top: 10px;
	width: 100%;
	padding: 14px 0;
	font-size: 26px;
	line-height: 1.4;
	font-weight: 500;
	border-radius: 999px;
	color: #2a2010;
	background: linear-gradient(to right, #e8d4b0, #d4b896, #c9a86c);
	cursor: pointer;
	box-shadow: 0 2px 4px rgba(0,0,0,0.06);
}
.detail-btn:active { transform: scale(0.97); }

/* 空状态 */
.empty-state {
	padding: 60px 20px 20px;
	text-align: center;
	color: #999;
}
.empty-state svg { display: block; margin: 0 auto 10px; }
.empty-text {
	font-size: 30px;
	color: #888;
	margin: 8px 0 4px;
}
/* V 认证徽章 + 昵称组合（卡片内尺寸，与首页保持一致） */
.name-with-badge {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	max-width: 100%;
	flex-wrap: nowrap;
}
.v-badge {
	display: inline-flex;
	flex-shrink: 0;
	align-items: center;
	gap: 6px;
	padding: 6px 12px;
	border-radius: 6px;
	background-image: linear-gradient(to right, #d4b896, #b8956a);
	color: #3d2f1a;
}
.v-badge-icon {
	width: 28px;
	height: 28px;
	display: inline-block;
	flex-shrink: 0;
}
.v-badge-text {
	font-size: 24px;
	font-weight: 600;
	color: #3d2f1a;
	line-height: 1;
	white-space: nowrap;
}

@media (max-width: 360px) {
	.teacher-img-wrap {
		width: 104px;
		height: 132px;
	}
}
</style>
